import './bootstrap';

import { Modal } from "bootstrap";
import { createApp, h, } from 'vue';
import { createInertiaApp, router, Link } from '@inertiajs/vue3';
import { ZiggyVue } from '../../vendor/tightenco/ziggy/dist/vue.m';

const appName = window.document.getElementsByTagName('title')[0]?.innerText || 'Laravel';

router.on('success', (event) => {
    let isAuthenticated = event.detail.page.props.user !== null;
    window.localStorage.setItem('isAuthenticated', isAuthenticated);
});

window.addEventListener('popstate', (event) => {
    if (window.localStorage.getItem('isAuthenticated') === 'false') {
        event.stopImmediatePropagation();
        router.replace('/login');
    }
});

createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    progress: {
        color: '#ffab00',
        showSpinner: true
    },
    resolve: (name) => require(`./Pages/${name}.vue`),
    setup({ el, App, props, plugin }) {
        return createApp({ render: () => h(App, props) })
            .use(plugin)
            .use(ZiggyVue, Ziggy)
            .component('inertia-link', Link)
            .mount(el);
    },
});